export default {
  taskDescription: 'Task Description',
  taskPlaceholder: 'Enter a task, e.g. inspect abnormal stacking in Zone A and capture qualified photos',
  buttons: {
    start: 'Start Task',
    stop: 'Stop Task',
    creating: 'Creating task...',
    running: 'Task running...',
    stopFirst: 'Stop the current task first',
  },
  kg: {
    title: 'Task-Matched Knowledge Graph Subgraph',
    subtitle: 'Map user tasks to related entities, actions, and collaboration relationships',
    emptyDesc: 'Enter a task description and click "Start Task" to parse the task and load the corresponding knowledge graph subgraph.',
  },
  video: {
    title: 'Robot Dog Live View',
  },
  progress: {
    title: 'Task Execution Progress',
    subtitle: 'Continuously display phases, subjects, escalation reasons, and step status',
    emptyDesc: 'Enter a task description and click "Start Task" to view execution steps in real time.',
  },
  empty: {
    waitingTitle: 'Waiting for task to start',
  },
  status: {
    online: 'Online',
    offline: 'Offline',
    unknown: 'Unknown',
    unnamedDevice: 'Unnamed Device',
  },
  messages: {
    taskStopped: 'Task stopped',
    stopFailed: 'Failed to stop task, please try again',
    taskNotCreated: 'Task has not been created yet',
    taskCreateFailed: 'Failed to create task',
    pipelineError500: 'Pipeline service error (500)',
    dogError500: 'Robot dog service error (500)',
    pipelineUnavailable404: 'Pipeline service unavailable (404)',
    dogUnavailable404: 'Robot dog service unavailable (404)',
    dogTaskNoId: 'Failed to create robot dog task: task_id not returned',
    pipelineNoRunId: 'Failed to create pipeline task: run_id not returned',
    connectionInterrupted: 'Connection interrupted. Please check the network or backend service.',
  },
  defaultTaskName: 'Daily Inspection Task',
}
